import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./users/authSlice";
import buildingReducer from "./buildings/buildingSlice";
import userReducer from "./users/userSlice";
import userAddEditReducer from "./users/userAddEditSlice";
import kindergartenScheduleReducer from "./schedule/kindergartenScheduleSlice";

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    auth: authReducer,
    building: buildingReducer,
    user: userReducer,
    userAddEdit: userAddEditReducer,
    kindergartenSchedule: kindergartenScheduleReducer,
    ...asyncReducers,
  });

  if (action.type === "auth/user/userLoggedOut") {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
